__turbopack_context__.v({
  "actions": "DKAgreementDetails-module-scss-module__kzU0-G__actions",
  "amountInput": "DKAgreementDetails-module-scss-module__kzU0-G__amountInput",
  "causeAreas": "DKAgreementDetails-module-scss-module__kzU0-G__causeAreas",
  "distributionCauseAreaInputContainer": "DKAgreementDetails-module-scss-module__kzU0-G__distributionCauseAreaInputContainer",
  "distributionCauseAreaInputHeader": "DKAgreementDetails-module-scss-module__kzU0-G__distributionCauseAreaInputHeader",
  "distributionCauseAreaInputPercentageShare": "DKAgreementDetails-module-scss-module__kzU0-G__distributionCauseAreaInputPercentageShare",
  "errorWrapper": "DKAgreementDetails-module-scss-module__kzU0-G__errorWrapper",
  "multiLayout": "DKAgreementDetails-module-scss-module__kzU0-G__multiLayout",
  "percentageInput": "DKAgreementDetails-module-scss-module__kzU0-G__percentageInput",
  "singleCauseAreaDistribution": "DKAgreementDetails-module-scss-module__kzU0-G__singleCauseAreaDistribution",
  "textWrapper": "DKAgreementDetails-module-scss-module__kzU0-G__textWrapper",
  "values": "DKAgreementDetails-module-scss-module__kzU0-G__values",
  "valuesAmountContainer": "DKAgreementDetails-module-scss-module__kzU0-G__valuesAmountContainer",
  "valuesDatePickerContainer": "DKAgreementDetails-module-scss-module__kzU0-G__valuesDatePickerContainer",
  "valuesSmartDistributionToggle": "DKAgreementDetails-module-scss-module__kzU0-G__valuesSmartDistributionToggle",
  "valuesTaxUnitSelectorContainer": "DKAgreementDetails-module-scss-module__kzU0-G__valuesTaxUnitSelectorContainer",
  "wrapper": "DKAgreementDetails-module-scss-module__kzU0-G__wrapper",
});
